import React, { Suspense, useMemo } from 'react'
import Card from 'src/components/Card'
import CardBody from './CardBody'
import { Table } from '@imcva/reactstrap-table'
import { createColumns } from './columns'
import { faPencil, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
import useToggleState from 'src/hooks/useToggleState'
import AddModal from './AddModal'
import EditModal from './EditModel'
import useToggleStateValue from 'src/hooks/useToggleStateValue'
import DeleteModal from './DeleteModel'

interface PointOfContactsProps {
  id: string
}

const PointOfContacts: React.FC<PointOfContactsProps> = (props) => {
  const { id } = props
  const [isOpen, , handleToggle] = useToggleState()
  const editModal = useToggleStateValue<string>()
  const deleteModal = useToggleStateValue<string>()

  const columns = useMemo(() => {
    return createColumns([
      {
        id: 'edit',
        title: 'Edit',
        icon: faPencil,
        onClick: editModal.toggle
      },
      {
        id: 'delete',
        title: 'Delete',
        icon: faTrash,
        color: 'danger',
        onClick: deleteModal.toggle
      }
    ])
  }, [editModal.toggle, deleteModal.toggle])

  return (
    <>
      <Card
        title='Point of Contacts'
        primaryAction={[
          {
            key: 'add-poc',
            icon: faPlus,
            text: 'Add POC',
            onClick: handleToggle,
            permissionKey: 'CAT_EDIT'
          }
        ]}
      >
        <Suspense fallback={<Table options={{ data: [], columns }} suspend={3} />}>
          <CardBody columns={columns} staffingAgency={id} />
        </Suspense>
      </Card>
      <AddModal isOpen={isOpen} toggle={handleToggle} staffingAgency={id} />
      <EditModal isOpen={editModal.hasState} toggle={editModal.toggle} id={editModal.value} staffingAgency={id} />
      <DeleteModal delete={deleteModal} staffingAgency={id} />
    </>
  )
}

export default PointOfContacts
